module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "touchstart": function($event) {
        $event.stopPropagation();
      },
      "touchmove": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-default w",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.selectedName || _vm.placeholder) + " "), _c('i', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), _c('div', {
    key: _vm.num + '-' + _vm.id,
    staticClass: "cont",
    class: {
      active: _vm.isActive,
      pt0: _vm.filter || _vm.btnShow
    },
    style: ({
      maxHeight: (_vm.maxHeight || 300) + 'px'
    }),
    attrs: {
      "id": _vm.id
    }
  }, [_c('ul', {
    staticClass: "beautyul"
  }, [(_vm.multiple && _vm.soptions.length && _vm.isShowSelectAll) ? _c('li', {
    staticClass: "select-condition"
  }, [(_vm.btnShow) ? _c('div', {
    staticClass: "btn-group btn-block btn-con-border mb10"
  }, [(_vm.showSelectBtn) ? _c('button', {
    staticClass: "btn btn-default select-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("全选")]) : _vm._e(), _vm._v(" "), (_vm.showCancelBtn) ? _c('button', {
    staticClass: "btn btn-default select-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelAll
    }
  }, [_vm._v("取消")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.filter) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterKey),
      expression: "filterKey"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.filterKey)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterKey = $event.target.value
      }, _vm.filterHandle]
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.soptions), function(o, index) {
    return _c('li', {
      key: o.name + index,
      class: {
        active: o.$isActive,
        disabled: o.$isDisabled,
        visibility: o.$isVisible,
      },
      on: {
        "click": function($event) {
          return _vm.selHandle(o, index)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(o[_vm.name]))]), _vm._v(" "), _c('i', {
      staticClass: "fa"
    })])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEmpty),
      expression: "isEmpty"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\t暂无数据\n\t\t\t")])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@12.1.0/~/vue-loader/lib/template-compiler?{"id":"data-v-0f29d35f"}!./~/.store/vue-loader@12.1.0/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/kxSelect/kxSelect.vue
// module id = 916
// module chunks = 76